import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#entity_target",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light" }, " Status of Training Activities Report ")
  ])
], -1)
const _hoisted_3 = {
  id: "entity_target",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "m-0 sticky" }
const _hoisted_7 = { class: "row w-100 mb-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 my-auto" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Status of Training Activities")
  ])
], -1)
const _hoisted_9 = {
  style: {"float":"right"},
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_17 = { class: "table table-bordered table-row-bordered table-row-gray-400 align-middle border border-gray-400 gs-2 gy-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("thead", { class: "sticky-header" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light text-black" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2",
      class: "align-middle border border-gray-400 sticky-header"
    }, " SN "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center","max-width":"150px !important"},
      rowspan: "2",
      class: "align-middle border border-gray-400 sticky-header"
    }, " Training Partner "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, [
      /*#__PURE__*/_createTextVNode(" Total Target "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" (As Per Contract) ")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      colspan: "2",
      class: "align-middle border border-gray-400 sticky-header"
    }, " Enrollment "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      colspan: "2",
      class: "align-middle border border-gray-400 sticky-header"
    }, " Certification "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      colspan: "3",
      class: "align-middle border border-gray-400 sticky-header"
    }, " Job Placement ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light text-black" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " % of Certified ")
  ])
], -1)
const _hoisted_19 = { style: {} }
const _hoisted_20 = { class: "fw-bolder bg-light" }
const _hoisted_21 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "10",
  class: "align-middle border border-gray-400"
}
const _hoisted_22 = {
  key: 0,
  class: "fw-bolder bg-light"
}
const _hoisted_23 = {
  key: 0,
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "25",
  class: "align-middle border border-gray-400"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = ["href"]
const _hoisted_28 = { class: "border border-gray-400 text-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, " Sub-Total ")
], -1)
const _hoisted_30 = { style: {"font-weight":"bold"} }
const _hoisted_31 = { style: {"font-weight":"bold"} }
const _hoisted_32 = { style: {"font-weight":"bold"} }
const _hoisted_33 = { style: {"font-weight":"bold"} }
const _hoisted_34 = { style: {"font-weight":"bold"} }
const _hoisted_35 = { style: {"font-weight":"bold"} }
const _hoisted_36 = { style: {"font-weight":"bold"} }
const _hoisted_37 = { style: {"font-weight":"bold"} }
const _hoisted_38 = {
  key: 2,
  class: "fw-bolder bg-light"
}
const _hoisted_39 = {
  key: 0,
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "10",
  class: "align-middle border border-gray-400"
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { key: 2 }
const _hoisted_43 = ["href"]
const _hoisted_44 = { class: "border border-gray-400 text-center" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, " Sub-Total ")
], -1)
const _hoisted_46 = { style: {"font-weight":"bold"} }
const _hoisted_47 = { style: {"font-weight":"bold"} }
const _hoisted_48 = { style: {"font-weight":"bold"} }
const _hoisted_49 = { style: {"font-weight":"bold"} }
const _hoisted_50 = { style: {"font-weight":"bold"} }
const _hoisted_51 = { style: {"font-weight":"bold"} }
const _hoisted_52 = { style: {"font-weight":"bold"} }
const _hoisted_53 = { style: {"font-weight":"bold"} }
const _hoisted_54 = {
  key: 4,
  class: "fw-bolder bg-light"
}
const _hoisted_55 = {
  key: 0,
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "10",
  class: "align-middle border border-gray-400"
}
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { key: 2 }
const _hoisted_59 = ["href"]
const _hoisted_60 = { class: "border border-gray-400 text-center" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, " Sub-Total ")
], -1)
const _hoisted_62 = { style: {"font-weight":"bold"} }
const _hoisted_63 = { style: {"font-weight":"bold"} }
const _hoisted_64 = { style: {"font-weight":"bold"} }
const _hoisted_65 = { style: {"font-weight":"bold"} }
const _hoisted_66 = { style: {"font-weight":"bold"} }
const _hoisted_67 = { style: {"font-weight":"bold"} }
const _hoisted_68 = { style: {"font-weight":"bold"} }
const _hoisted_69 = { style: {"font-weight":"bold"} }
const _hoisted_70 = {
  key: 6,
  class: "fw-bolder bg-light"
}
const _hoisted_71 = {
  key: 0,
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "10",
  class: "align-middle border border-gray-400"
}
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = { key: 2 }
const _hoisted_75 = ["href"]
const _hoisted_76 = { class: "border border-gray-400 text-center" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, " Sub-Total ")
], -1)
const _hoisted_78 = { style: {"font-weight":"bold"} }
const _hoisted_79 = { style: {"font-weight":"bold"} }
const _hoisted_80 = { style: {"font-weight":"bold"} }
const _hoisted_81 = { style: {"font-weight":"bold"} }
const _hoisted_82 = { style: {"font-weight":"bold"} }
const _hoisted_83 = { style: {"font-weight":"bold"} }
const _hoisted_84 = { style: {"font-weight":"bold"} }
const _hoisted_85 = { style: {"font-weight":"bold"} }
const _hoisted_86 = {
  key: 8,
  class: "border border-gray-400 text-center"
}
const _hoisted_87 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "2"
}
const _hoisted_88 = /*#__PURE__*/_createElementVNode("span", null, "(A+B+C)", -1)
const _hoisted_89 = { style: {"font-weight":"bold"} }
const _hoisted_90 = { style: {"font-weight":"bold"} }
const _hoisted_91 = { style: {"font-weight":"bold"} }
const _hoisted_92 = { style: {"font-weight":"bold"} }
const _hoisted_93 = { style: {"font-weight":"bold"} }
const _hoisted_94 = { style: {"font-weight":"bold"} }
const _hoisted_95 = { style: {"font-weight":"bold"} }
const _hoisted_96 = { style: {"font-weight":"bold"} }
const _hoisted_97 = {
  key: 9,
  class: "border border-gray-400 text-center"
}
const _hoisted_98 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "2"
}
const _hoisted_99 = /*#__PURE__*/_createElementVNode("span", null, "(D+E+F+G)", -1)
const _hoisted_100 = { style: {"font-weight":"bold"} }
const _hoisted_101 = { style: {"font-weight":"bold"} }
const _hoisted_102 = { style: {"font-weight":"bold"} }
const _hoisted_103 = { style: {"font-weight":"bold"} }
const _hoisted_104 = { style: {"font-weight":"bold"} }
const _hoisted_105 = { style: {"font-weight":"bold"} }
const _hoisted_106 = { style: {"font-weight":"bold"} }
const _hoisted_107 = { style: {"font-weight":"bold"} }
const _hoisted_108 = {
  key: 10,
  class: "border border-gray-400 text-center"
}
const _hoisted_109 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "2"
}
const _hoisted_110 = /*#__PURE__*/_createElementVNode("span", null, "(H+I+J+K)", -1)
const _hoisted_111 = { style: {"font-weight":"bold"} }
const _hoisted_112 = { style: {"font-weight":"bold"} }
const _hoisted_113 = { style: {"font-weight":"bold"} }
const _hoisted_114 = { style: {"font-weight":"bold"} }
const _hoisted_115 = { style: {"font-weight":"bold"} }
const _hoisted_116 = { style: {"font-weight":"bold"} }
const _hoisted_117 = { style: {"font-weight":"bold"} }
const _hoisted_118 = { style: {"font-weight":"bold"} }
const _hoisted_119 = { class: "border border-gray-400 text-center" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Grand Total (All Tranches) ")
], -1)
const _hoisted_121 = { style: {"font-weight":"bold"} }
const _hoisted_122 = { style: {"font-weight":"bold"} }
const _hoisted_123 = { style: {"font-weight":"bold"} }
const _hoisted_124 = { style: {"font-weight":"bold"} }
const _hoisted_125 = { style: {"font-weight":"bold"} }
const _hoisted_126 = { style: {"font-weight":"bold"} }
const _hoisted_127 = { style: {"font-weight":"bold"} }
const _hoisted_128 = { style: {"font-weight":"bold"} }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("div", { id: "note" }, " N.B: The job placement percentage excludes the special courses with no job placement target. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                  title: "Download Xlse",
                  "data-v-54b12dc8": "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exportTrainee()))
                }, _hoisted_11),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                  title: "Download PDF",
                  "data-v-54b12dc8": "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadPdf()))
                }, _hoisted_13),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                  title: "Print",
                  "data-v-54b12dc8": "",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printPdf()))
                }, _hoisted_15),
                _hoisted_16
              ])
            ]),
            _createElementVNode("table", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("tbody", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.tmsdashboardInfo, (info, key) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                    _createElementVNode("tr", _hoisted_20, [
                      _createElementVNode("td", _hoisted_21, [
                        _createElementVNode("b", null, _toDisplayString(info?.trancheInfo?.label), 1)
                      ])
                    ]),
                    (
                      info?.trancheInfo?.industry_association?.association
                        .length > 0
                    )
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                          (
                        info?.trancheInfo?.industry_association?.association
                          .length > 0
                      )
                            ? (_openBlock(), _createElementBlock("td", _hoisted_23, [
                                (info?.trancheInfo?.id == 1)
                                  ? (_openBlock(), _createElementBlock("b", _hoisted_24, " A. Industry Associations "))
                                  : _createCommentVNode("", true),
                                (info?.trancheInfo?.id == 2)
                                  ? (_openBlock(), _createElementBlock("b", _hoisted_25, " D. Industry Associations "))
                                  : _createCommentVNode("", true),
                                (info?.trancheInfo?.id == 5)
                                  ? (_openBlock(), _createElementBlock("b", _hoisted_26, " H. Industry Associations "))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (
                      info?.trancheInfo?.industry_association?.association
                        .length > 0
                    )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.trancheInfo
                        ?.industry_association?.association, (data, inx) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: inx,
                              class: "border border-gray-400 text-center"
                            }, [
                              _createElementVNode("td", null, _toDisplayString(data?.sl), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("a", {
                                  href: 
                              `${this.VUE_APP_TMS}/course-summary/2/` +
                              info?.trancheInfo?.id +
                              '/' +
                              data?.id
                            ,
                                  target: "_blank",
                                  class: "text-primary fw-bold fs-6 mt-2"
                                }, _toDisplayString(data?.entity_short_name), 9, _hoisted_27)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.targetTrainee).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.enrollment).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.female_enrollment).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.certification).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.female_certification).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.job_placement).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.job_placement_female).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString((data?.percentage_of_job_placement || 0) > 100
                              ? 100
                              : data?.percentage_of_job_placement
                              ? parseFloat(
                                  data?.percentage_of_job_placement
                                ).toFixed(2)
                              : 0), 1)
                            ]))
                          }), 128)),
                          _createElementVNode("tr", _hoisted_28, [
                            _hoisted_29,
                            _createElementVNode("td", _hoisted_30, _toDisplayString(Number(
                            info?.trancheInfo?.industry_association
                              ?.subTotalTrainee
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_31, _toDisplayString(Number(
                            info?.trancheInfo?.industry_association
                              ?.subTotalEnrollment
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_32, _toDisplayString(Number(
                            info?.trancheInfo?.industry_association
                              ?.subTotalfemaleEnrollment
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_33, _toDisplayString(Number(
                            info?.trancheInfo?.industry_association
                              ?.subTotalCertification
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_34, _toDisplayString(Number(
                            info?.trancheInfo?.industry_association
                              ?.subTotalfemaleCertification
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_35, _toDisplayString(Number(
                            info?.trancheInfo?.industry_association
                              ?.subTotalJobPlacement
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_36, _toDisplayString(Number(
                            info?.trancheInfo?.industry_association
                              ?.subTotalfemaleJobPlacement
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_37, _toDisplayString(Number(
                            info?.trancheInfo?.industry_association
                              ?.subTotalPercentageOfJobPlacement
                          ).toFixed(2)), 1)
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (info?.trancheInfo?.gov_org?.association.length > 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_38, [
                          (info?.trancheInfo?.gov_org?.association.length > 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_39, [
                                (info?.trancheInfo?.id == 1)
                                  ? (_openBlock(), _createElementBlock("b", _hoisted_40, " B. Govt. Partners "))
                                  : _createCommentVNode("", true),
                                (info?.trancheInfo?.id == 2)
                                  ? (_openBlock(), _createElementBlock("b", _hoisted_41, " E. Govt. Partners "))
                                  : _createCommentVNode("", true),
                                (info?.trancheInfo?.id == 5)
                                  ? (_openBlock(), _createElementBlock("b", _hoisted_42, " I. Govt. Partners "))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (info?.trancheInfo?.gov_org?.association.length > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.trancheInfo?.gov_org
                        ?.association, (data, inx) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: inx,
                              class: "border border-gray-400 text-center"
                            }, [
                              _createElementVNode("td", null, _toDisplayString(data?.sl), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("a", {
                                  href: 
                              `${this.VUE_APP_TMS}/course-summary/2/` +
                              info?.trancheInfo?.id +
                              '/' +
                              data?.id
                            ,
                                  target: "_blank",
                                  class: "text-primary fw-bold fs-6 mt-2"
                                }, _toDisplayString(data?.entity_short_name), 9, _hoisted_43)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.targetTrainee).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.enrollment).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.female_enrollment).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.certification).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.female_certification).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.job_placement).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.job_placement_female).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString((data?.percentage_of_job_placement || 0) > 100
                              ? 100
                              : data?.percentage_of_job_placement
                              ? parseFloat(
                                  data?.percentage_of_job_placement
                                ).toFixed(2)
                              : 0), 1)
                            ]))
                          }), 128)),
                          _createElementVNode("tr", _hoisted_44, [
                            _hoisted_45,
                            _createElementVNode("td", _hoisted_46, _toDisplayString(Number(
                            info?.trancheInfo?.gov_org?.subTotalTrainee
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_47, _toDisplayString(Number(
                            info?.trancheInfo?.gov_org?.subTotalEnrollment
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_48, _toDisplayString(Number(
                            info?.trancheInfo?.gov_org?.subTotalfemaleEnrollment
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_49, _toDisplayString(Number(
                            info?.trancheInfo?.gov_org?.subTotalCertification
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_50, _toDisplayString(Number(
                            info?.trancheInfo?.gov_org
                              ?.subTotalfemaleCertification
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_51, _toDisplayString(Number(
                            info?.trancheInfo?.gov_org?.subTotalJobPlacement
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_52, _toDisplayString(Number(
                            info?.trancheInfo?.gov_org
                              ?.subTotalfemaleJobPlacement
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_53, _toDisplayString(Number(
                            info?.trancheInfo?.gov_org
                              ?.subTotalPercentageOfJobPlacement
                          ).toFixed(2)), 1)
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (
                      info?.trancheInfo?.motor_driving?.association.length > 0
                    )
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_54, [
                          (
                        info?.trancheInfo?.motor_driving?.association.length > 0
                      )
                            ? (_openBlock(), _createElementBlock("td", _hoisted_55, [
                                (info?.trancheInfo?.id == 1)
                                  ? (_openBlock(), _createElementBlock("b", _hoisted_56, " C. Motor Driving"))
                                  : _createCommentVNode("", true),
                                (info?.trancheInfo?.id == 2)
                                  ? (_openBlock(), _createElementBlock("b", _hoisted_57, " F. Motor Driving"))
                                  : _createCommentVNode("", true),
                                (info?.trancheInfo?.id == 5)
                                  ? (_openBlock(), _createElementBlock("b", _hoisted_58, " J. Motor Driving"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (
                      info?.trancheInfo?.motor_driving?.association.length > 0
                    )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.trancheInfo?.motor_driving
                        ?.association, (data, inx) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: inx,
                              class: "border border-gray-400 text-center"
                            }, [
                              _createElementVNode("td", null, _toDisplayString(data?.sl), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("a", {
                                  href: 
                              `${this.VUE_APP_TMS}/course-summary/1/` +
                              info?.trancheInfo?.id +
                              '/' +
                              data?.id
                            ,
                                  target: "_blank",
                                  class: "text-primary fw-bold fs-6 mt-2"
                                }, _toDisplayString(data?.entity_short_name), 9, _hoisted_59)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.targetTrainee).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.enrollment).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.female_enrollment).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.certification).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.female_certification).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.job_placement).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.job_placement_female).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString((data?.percentage_of_job_placement || 0) > 100
                              ? 100
                              : data?.percentage_of_job_placement
                              ? parseFloat(
                                  data?.percentage_of_job_placement
                                ).toFixed(2)
                              : 0), 1)
                            ]))
                          }), 128)),
                          _createElementVNode("tr", _hoisted_60, [
                            _hoisted_61,
                            _createElementVNode("td", _hoisted_62, _toDisplayString(Number(
                            info?.trancheInfo?.motor_driving?.subTotalTrainee
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_63, _toDisplayString(Number(
                            info?.trancheInfo?.motor_driving?.subTotalEnrollment
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_64, _toDisplayString(Number(
                            info?.trancheInfo?.motor_driving
                              ?.subTotalfemaleEnrollment
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_65, _toDisplayString(Number(
                            info?.trancheInfo?.motor_driving
                              ?.subTotalCertification
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_66, _toDisplayString(Number(
                            info?.trancheInfo?.motor_driving
                              ?.subTotalfemaleCertification
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_67, _toDisplayString(Number(
                            info?.trancheInfo?.motor_driving
                              ?.subTotalJobPlacement
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_68, _toDisplayString(Number(
                            info?.trancheInfo?.motor_driving
                              ?.subTotalfemaleJobPlacement
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_69, _toDisplayString(Number(
                            info?.trancheInfo?.motor_driving
                              ?.subTotalPercentageOfJobPlacement
                          ).toFixed(2)), 1)
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (info?.trancheInfo?.edc?.association.length > 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_70, [
                          (info?.trancheInfo?.edc?.association.length > 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_71, [
                                (info?.trancheInfo?.id == 1)
                                  ? (_openBlock(), _createElementBlock("b", _hoisted_72, " I. Excecutive Development Program"))
                                  : _createCommentVNode("", true),
                                (info?.trancheInfo?.id == 2)
                                  ? (_openBlock(), _createElementBlock("b", _hoisted_73, " G. Excecutive Development Program"))
                                  : _createCommentVNode("", true),
                                (info?.trancheInfo?.id == 5)
                                  ? (_openBlock(), _createElementBlock("b", _hoisted_74, " K. Excecutive Development Program"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (info?.trancheInfo?.edc?.association.length > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.trancheInfo?.edc?.association, (data, inx) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: inx,
                              class: "border border-gray-400 text-center"
                            }, [
                              _createElementVNode("td", null, _toDisplayString(data?.sl), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("a", {
                                  href: 
                              `${this.VUE_APP_TMS}/course-summary/2/` +
                              info?.trancheInfo?.id +
                              '/' +
                              data?.id
                            ,
                                  target: "_blank",
                                  class: "text-primary fw-bold fs-6 mt-2"
                                }, _toDisplayString(data?.entity_short_name), 9, _hoisted_75)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.targetTrainee).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.enrollment).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.female_enrollment).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.certification).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.female_certification).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.job_placement).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString(Number(data?.job_placement_female).toLocaleString()), 1),
                              _createElementVNode("td", null, _toDisplayString((data?.percentage_of_job_placement || 0) > 100
                              ? 100
                              : data?.percentage_of_job_placement
                              ? parseFloat(
                                  data?.percentage_of_job_placement
                                ).toFixed(2)
                              : 0), 1)
                            ]))
                          }), 128)),
                          _createElementVNode("tr", _hoisted_76, [
                            _hoisted_77,
                            _createElementVNode("td", _hoisted_78, _toDisplayString(Number(
                            info?.trancheInfo?.edc?.subTotalTrainee
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_79, _toDisplayString(Number(
                            info?.trancheInfo?.edc?.subTotalEnrollment
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_80, _toDisplayString(Number(
                            info?.trancheInfo?.edc?.subTotalfemaleEnrollment
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_81, _toDisplayString(Number(
                            info?.trancheInfo?.edc?.subTotalCertification
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_82, _toDisplayString(Number(
                            info?.trancheInfo?.edc?.subTotalfemaleCertification
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_83, _toDisplayString(Number(
                            info?.trancheInfo?.edc?.subTotalJobPlacement
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_84, _toDisplayString(Number(
                            info?.trancheInfo?.edc?.subTotalfemaleJobPlacement
                          ).toLocaleString()), 1),
                            _createElementVNode("td", _hoisted_85, _toDisplayString(Number(
                            info?.trancheInfo?.edc
                              ?.subTotalPercentageOfJobPlacement
                          ).toFixed(2)), 1)
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (info?.trancheInfo?.id == 1 && _ctx.is_seip_user == true)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_86, [
                          _createElementVNode("td", _hoisted_87, [
                            _createElementVNode("b", null, [
                              _createTextVNode("Total " + _toDisplayString(info?.trancheInfo?.label) + " ", 1),
                              _hoisted_88
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_89, _toDisplayString(Number(
                          info?.trancheInfo?.TotalTargetTrainee
                        ).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_90, _toDisplayString(Number(
                          info?.trancheInfo?.TotalEnrollment
                        ).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_91, _toDisplayString(Number(
                          info?.trancheInfo?.TotalFemaleEnrollment
                        ).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_92, _toDisplayString(Number(
                          info?.trancheInfo?.TotalCertificate
                        ).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_93, _toDisplayString(Number(
                          info?.trancheInfo?.TotalCertificateFemale
                        ).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_94, _toDisplayString(Number(info?.trancheInfo?.TotalJob).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_95, _toDisplayString(Number(
                          info?.trancheInfo?.TotalJobFemale
                        ).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_96, _toDisplayString(Number(
                          info?.trancheInfo?.Total_percentage_of_job_placement
                        ).toFixed(2)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (info?.trancheInfo?.id == 2 && _ctx.is_seip_user == true)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_97, [
                          _createElementVNode("td", _hoisted_98, [
                            _createElementVNode("b", null, [
                              _createTextVNode("Total " + _toDisplayString(info?.trancheInfo?.label) + " ", 1),
                              _hoisted_99
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_100, _toDisplayString(Number(
                          info?.trancheInfo?.TotalTargetTrainee
                        ).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_101, _toDisplayString(Number(
                          info?.trancheInfo?.TotalEnrollment
                        ).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_102, _toDisplayString(Number(
                          info?.trancheInfo?.TotalFemaleEnrollment
                        ).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_103, _toDisplayString(Number(
                          info?.trancheInfo?.TotalCertificate
                        ).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_104, _toDisplayString(Number(
                          info?.trancheInfo?.TotalCertificateFemale
                        ).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_105, _toDisplayString(Number(info?.trancheInfo?.TotalJob).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_106, _toDisplayString(Number(
                          info?.trancheInfo?.TotalJobFemale
                        ).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_107, _toDisplayString(Number(
                          info?.trancheInfo?.Total_percentage_of_job_placement
                        ).toFixed(2)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (info?.trancheInfo?.id == 5 && _ctx.is_seip_user == true)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_108, [
                          _createElementVNode("td", _hoisted_109, [
                            _createElementVNode("b", null, [
                              _createTextVNode("Total " + _toDisplayString(info?.trancheInfo?.label) + " ", 1),
                              _hoisted_110
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_111, _toDisplayString(Number(
                          info?.trancheInfo?.TotalTargetTrainee
                        ).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_112, _toDisplayString(Number(
                          info?.trancheInfo?.TotalEnrollment
                        ).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_113, _toDisplayString(Number(
                          info?.trancheInfo?.TotalFemaleEnrollment
                        ).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_114, _toDisplayString(Number(
                          info?.trancheInfo?.TotalCertificate
                        ).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_115, _toDisplayString(Number(
                          info?.trancheInfo?.TotalCertificateFemale
                        ).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_116, _toDisplayString(Number(info?.trancheInfo?.TotalJob).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_117, _toDisplayString(Number(
                          info?.trancheInfo?.TotalJobFemale
                        ).toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_118, _toDisplayString(Number(
                          info?.trancheInfo?.Total_percentage_of_job_placement
                        ).toFixed(2)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                _createElementVNode("tr", _hoisted_119, [
                  _hoisted_120,
                  _createElementVNode("td", _hoisted_121, _toDisplayString(Number(this.GrandTotalTargetTrainee).toLocaleString()), 1),
                  _createElementVNode("td", _hoisted_122, _toDisplayString(Number(this.GrandTotalEnrollment).toLocaleString()), 1),
                  _createElementVNode("td", _hoisted_123, _toDisplayString(Number(this.GrandTotalFemaleEnrollment).toLocaleString()), 1),
                  _createElementVNode("td", _hoisted_124, _toDisplayString(this.GrandTotalCertificate.toLocaleString()), 1),
                  _createElementVNode("td", _hoisted_125, _toDisplayString(this.GrandTotalCertificateFemale.toLocaleString()), 1),
                  _createElementVNode("td", _hoisted_126, _toDisplayString(this.GrandTotalJob.toLocaleString()), 1),
                  _createElementVNode("td", _hoisted_127, _toDisplayString(this.GrandTotalJobFemale.toLocaleString()), 1),
                  _createElementVNode("td", _hoisted_128, _toDisplayString(this.Grand_Total_percentage_of_job_placement.toFixed(2)), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _hoisted_129
    ])
  ])), [
    [_directive_loading, _ctx.load]
  ])
}